import React from "react";
import Marquee from "react-fast-marquee";
import {
  Wrench,
  Zap,
  Hammer,
  HardHat,
  Flame,
  Home,
  Paintbrush,
  Trees,
  Bug,
  Scissors,
  Heart,
  Sparkles,
  Square,
} from "lucide-react";

const trades = [
  { name: "Plumbers", icon: Wrench, color: "bg-[var(--blue)] text-white" },
  { name: "Electricians", icon: Zap, color: "bg-[var(--yellow)] text-ink" },
  { name: "Glaziers", icon: Square, color: "bg-white text-ink" },
  { name: "Carpenters", icon: Hammer, color: "bg-[var(--pink)] text-white" },
  { name: "Builders", icon: HardHat, color: "bg-white text-ink" },
  { name: "Gas Engineers", icon: Flame, color: "bg-[var(--yellow)] text-ink" },
  { name: "Roofers", icon: Home, color: "bg-[var(--blue)] text-white" },
  {
    name: "Painters & Decorators",
    icon: Paintbrush,
    color: "bg-[var(--pink)] text-white",
  },
  { name: "Landscapers", icon: Trees, color: "bg-white text-ink" },
  { name: "Fumigators", icon: Bug, color: "bg-[var(--yellow)] text-ink" },
  { name: "Mobile Haircare", icon: Scissors, color: "bg-[var(--pink)] text-white" },
  { name: "Massage Therapists", icon: Heart, color: "bg-[var(--blue)] text-white" },
  { name: "Domestic Cleaners", icon: Sparkles, color: "bg-white text-ink" },
];

const photoStrip = [
  {
    url: "https://images.unsplash.com/photo-1649769069590-268b0b994462?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxmcmllbmRseSUyMHBsdW1iZXIlMjB3b3JraW5nfGVufDB8fHx8MTc3OTIzMDU2M3ww&ixlib=rb-4.1.0&q=85",
    label: "Plumbers",
  },
  {
    url: "https://images.pexels.com/photos/9679179/pexels-photo-9679179.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Electricians",
  },
  {
    url: "https://images.pexels.com/photos/7755226/pexels-photo-7755226.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Mobile Haircare",
  },
  {
    url: "https://images.pexels.com/photos/30467599/pexels-photo-30467599.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Landscapers",
  },
];

export const WhoWeHelp = () => {
  return (
    <section
      id="who-we-help"
      data-testid="who-we-help-section"
      className="border-b-2 border-ink py-24 lg:py-32 bg-[var(--cream)] relative overflow-hidden"
    >
      {/* tape strip */}
      <div className="absolute top-0 left-0 right-0 h-3 tape" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="uppercase text-sm font-bold tracking-[0.25em] text-[var(--pink)]">
            Who we help
          </p>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
            Built for the trades. <br />
            <span className="text-[var(--pink)]">Loved</span> by solo bosses.
          </h2>
          <p className="mt-5 text-lg text-stone-700">
            If you wear all the hats — sales, ops, customer support, accounts —
            we're for you. We speak your language, not Silicon Valley's.
          </p>
        </div>

        {/* Marquee of trades */}
        <div className="relative mt-14 fade-edges" data-testid="trades-marquee">
          <Marquee speed={45} gradient={false} pauseOnHover>
            {trades.map((t, i) => {
              const Icon = t.icon;
              return (
                <div
                  key={`${t.name}-${i}`}
                  className={`mx-3 inline-flex items-center gap-3 px-5 py-3 border-2 border-ink rounded-full shadow-brutal ${t.color} whitespace-nowrap font-bold`}
                  data-testid={`trade-pill-${t.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <Icon size={18} /> {t.name}
                </div>
              );
            })}
          </Marquee>
        </div>

        {/* Photo strip */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-5">
          {photoStrip.map((p, i) => (
            <div
              key={p.url}
              data-testid={`who-we-help-photo-${i}`}
              className={`relative border-2 border-ink rounded-2xl overflow-hidden shadow-brutal-hover shadow-brutal bg-white ${
                i % 2 === 0 ? "rotate-[-1.5deg]" : "rotate-[1.5deg]"
              }`}
            >
              <img
                src={p.url}
                alt={p.label}
                className="h-56 w-full object-cover"
              />
              <div className="absolute bottom-3 left-3 bg-white border-2 border-ink rounded-full px-3 py-1 text-sm font-bold">
                {p.label}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center mt-10 text-stone-700">
          …and many more: dog groomers, mobile mechanics, tutors, photographers,
          florists, personal trainers. If you take bookings, we can help.
        </p>
      </div>
    </section>
  );
};
